export const PARTNER_CARD_TEST_ID = 'partner-card';
